import Papa from 'papaparse';

type Callback = (data:any) => void;

const useFetch = () => {

    const sanitizeColumns = (data: any) => {
        return data.map((item: any) => {
            const sanitizedItem: any = {};
            Object.keys(item).forEach(key => {
                const sanitizedKey = key.toLowerCase().replace(/(\s|-)+/g , '_');
                sanitizedItem[sanitizedKey] = item[key];
            })
            return sanitizedItem
        })
    }

    const fetchCsvData = async (filePath: string, callback: Callback) => {
        const response = await fetch(filePath);
        const reader = response.body!.getReader();
        const decoder = new TextDecoder('utf-8');
        let result = '';
        let done = false;

        while (!done) {
            const { value, done: readerDone } = await reader.read();
            if (value) {
                result += decoder.decode(value, { stream: true });
            }
            done = readerDone;
        }

        result += decoder.decode(); // flush any remaining bytes

        const { data } = Papa.parse(result, {
            header: true,
            dynamicTyping: {
                imports: true,
                tariff: true,
                tot: true,
                par: false,      
                rep: false,
                hs_code:false         
              },
            skipEmptyLines: true,
        });

        const sanitizedData = await sanitizeColumns(data);
        callback(sanitizedData);

    }

    return { fetchCsvData }

}

export default useFetch;